module.exports = __webpack_public_path__ + "img/cooperateimg.8ccaaf9d.png";